var url;
if ((!process.env.NODE_ENV || process.env.NODE_ENV === 'development')) {
    url = "http://localhost:8000";
} else {
    url = "https://backend.neutrinos.tamtanguy.fr";
}
export const api_url = url;